/**
 * Cómo se escriben las fechas de cara a una persona.
 *
 * Vive aparte porque lo usan la pantalla del administrador y la app del
 * residente, y son el **mismo aviso**: la fecha que ve quien lo manda tiene que
 * leerse igual que la que ve quien lo recibe.
 */

/**
 * «29 de agosto a las 12:43 p.m.»
 *
 * `toLocaleString` sin opciones añade los segundos —«12:43:59 p.m.»— y en un
 * aviso de la administración esa precisión no le sirve a nadie: solo alarga el
 * renglón y, en un teléfono, se come una línea entera.
 */
export function cuando(iso: string): string {
  return new Date(iso).toLocaleString('es-MX', {
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
  });
}
